import React, { useState, useEffect } from 'react';
import { systemAPI } from '../services/api';

const MobileAppSection = () => {
  const [systemSettings, setSystemSettings] = useState(null);

  useEffect(() => {
    fetchSystemSettings();
  }, []);

  const fetchSystemSettings = async () => {
    try {
      const settings = await systemAPI.getSystemSettings();
      setSystemSettings(settings);
    } catch (error) {
      console.error('Failed to fetch system settings:', error);
    }
  };

  const siteName = systemSettings?.siteName || 'Bus Ticket System';

  return (
    <section className="py-8 md:py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center">
          {/* Image Section */}
          <div className="flex justify-center">
            <img src="/images/mobile_app.png" alt="Mobile App" className="max-w-full h-auto" />
          </div>

          {/* Content Section */}
          <div>
            <h2 className="text-2xl md:text-4xl font-bold text-gray-800 mb-3 md:mb-4">Get More Out of {siteName} with our mobile app</h2>
            <p className="text-base md:text-lg text-gray-600 mb-4 md:mb-6">
              With the {siteName} mobile app, you can purchase bus tickets with the help of your mobile phone. It is a very user-friendly app that provides the facility of booking bus tickets to your favorite routes. So you can choose and book your bus tickets easily.
            </p>
            <ul className="list-disc list-inside text-gray-600 mb-8">
              <li>Easy to use and simple booking process</li>
              <li>Instant ticket confirmation</li>
              <li>Secure payment options</li>
              <li>24/7 customer support</li>
            </ul>
            <div className="flex flex-wrap gap-4">
              <a href={systemSettings?.iosAppUrl} className="inline-block">
                <img src="/images/app-store.png" alt="App Store" className="h-12" />
              </a>
              <a href={systemSettings?.androidAppUrl} className="inline-block">
                <img src="/images/google-play.png" alt="Google Play" className="h-12" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MobileAppSection;